export default {
  getListCTG (state) {
    return state.list_category_chk
  },
  getListRecursive (state) {
    return state.list_category_chk_recursive
  },

  getTotal (state) {
    return state.total
  },
  getLastpage (state) {
    return state.last_page
  },
  getFAQSelect (state) {
    return state.faq_select.faq
  },
  getCommentOfFAQSelect (state) {
    return state.faq_select.comment
  },
  getField (state) {
    return state.fields
  }
}



// WEBPACK FOOTER //
// ./src/store/module/category-chk/getters.js